// extracted by mini-css-extract-plugin
module.exports = {"select":"SelectCurrency_select__3Wvll","addon":"SelectCurrency_addon__3lM3z"};